import React, { useEffect } from 'react';
import { GOOGLE_REVIEW_URL } from '../config/api';

export default function TestimonialsSection() {
  useEffect(() => {
    // Load Elfsight platform script for Google Reviews widget
    const existingScript = document.querySelector('script[src="https://elfsightcdn.com/platform.js"]');

    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://elfsightcdn.com/platform.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section style={{
      background: 'var(--color-bg)',
      padding: '60px 32px',
    }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 48 }}>
          <h2 style={{
            fontFamily: 'var(--font-display)',
            fontSize: 32,
            fontWeight: 400,
            color: 'var(--color-text-primary)',
            marginTop: 0,
            marginBottom: 16,
          }}>
            Kind Words From My Clients
          </h2>
        </div>

        {/* Google Reviews Widget - Centered */}
        <div style={{
          maxWidth: 800,
          margin: '0 auto',
          background: 'var(--color-surface)',
          padding: 24,
          border: '1px solid var(--color-border)',
          borderRadius: 0,
          minHeight: 300,
        }}>
          <div
            className="elfsight-app-3e6729b6-e881-4189-8949-cbd035193fc6"
            data-elfsight-app-lazy
            style={{
              width: '100%'
            }}
          />
        </div>

        {/* Leave a Review Button */}
        <div style={{ textAlign: 'center', marginTop: 32 }}>
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              background: 'var(--color-accent)',
              color: '#fff',
              border: 'none',
              padding: '12px 32px',
              fontSize: 11,
              letterSpacing: '0.1em',
              textTransform: 'uppercase',
              textDecoration: 'none',
              fontFamily: 'var(--font-body)',
              borderRadius: 0,
            }}
          >
            Leave a Review on Google →
          </a>
        </div>
      </div>
    </section>
  );
}
